"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/Modals/NoticeBar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);








const NoticeBar = ({ isOpen, text, type, onClose }) => {
  const hideTimeout = _react.useRef(undefined)

  // componentDidMount and componentDidUpdate: after every render while open
  // (not only when `isOpen` changes), restart the 3s hide timer.
  _react.useLayoutEffect.call(void 0, () => {
    if (!isOpen) return
    clearTimeout(hideTimeout.current)
    hideTimeout.current = setTimeout(onClose, 3000)
  })

  // componentWillUnmount
  _react.useLayoutEffect.call(void 0, () => () => clearTimeout(hideTimeout.current), [])

  const rootClassName = _classBuilder2.default.call(void 0, 
    'video-call--notice-bar--wrapper',
    { hidden: !isOpen },
  )

  return (
    _react2.default.createElement('div', { className: rootClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
      , _react2.default.createElement('div', { className: "video-call--notice-bar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
        ,  type === "success" &&
          _react2.default.createElement('img', { src: "/assets/icons/tick-green.svg", alt: "&check;", __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}} )
        
        ,  type === "warning" &&
          _react2.default.createElement('img', { src: "/assets/icons/alert-orange.svg", alt: "<!>", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}} )
        
        , _react2.default.createElement('span', { className: "video-call--notice-bar--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}},  text )
      )
    )
  )
}

exports. default = NoticeBar
